export const getAsNumber = (data) => {
    const num = parseFloat(data);

    return isNaN(num)? 0 : num
} 